// You can write your custom Javascript here
$(document).ready(function () {
  //   var a = window.location.href;
  //   var parts = a.split("/");
  //   console.log(parts);
  //   var tmp = parts[parts.length - 1].split("+");

  //   console.log(tmp);

  //   var i;
  //   var result;
  //   for (i = 0; i < tmp.length; ++i) {
  //        result = '.'+ tmp[i];
  //     	$(result).addClass("selected");
  //   }

  //   var listItems = $(".bc-sf-filter-option-block .bc-sf-filter-block-content .bc-sf-filter-option-single-list li");
  //   listItems.each(function(idx, li) {

  //     $(li).find('a').click(function (e) {
  //       e.preventDefault();

  //       var tag = $(this).attr("class");
  //       console.log(tmp);
  //       if(tmp.length > 0) {
  //           var url = document.location.href+"+"+tag;
  //       }else{
  //           var url = document.location.href+tag;
  //       }

  //       document.location = url;

  //     });

  //       // and the rest of your code
  //   });

  const checkoutBtn = document.querySelector('.js-btn-checkout');

  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const form = checkoutBtn.closest('form');
      const select = form.querySelector('[name="id"]');
      const quantity = form.querySelector('[name="quantity"]');
      const formData = {
        items: [
          {
            id: select.value,
            quantity: quantity.value,
          },
        ],
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(response.statusText);
          }

          window.location.href = window.Shopify.routes.root + 'checkout';
        })
        .catch((error) => {
          console.error('Error:', error);
          alert(error);
        });
    });
  }

  const navDropdownLinks = document.querySelectorAll(
    '.nav-wrapper .nav li.menu__item--has-dropdown > a'
  );

  navDropdownLinks.forEach((link) => {
    const $dropdown = $(link.nextElementSibling);

    link.addEventListener('click', (e) => {
      if (!window.matchMedia('(max-width: 767px)').matches) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      link.classList.toggle('is-open');
      $dropdown.toggle();
    });
  });

  // Slide product gallery to the selected variant's featured image
  if (!window.__gmVariantImageBound) {
    window.__gmVariantImageBound = true;

    function normalizeImageFilename(url) {
      if (!url) return '';
      var file = String(url).split('?')[0].split('/').pop();
      return file
        .replace(/_\d+x\d*(@2x)?/i, '')
        .replace(/\.(jpg|jpeg|png|gif|webp)$/i, '');
    }

    function findProductVariant(variantId) {
      var product = window.Shopify && Shopify.product;
      if (!product || !product.variants) return null;

      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(variantId)) {
          return product.variants[i];
        }
      }

      return null;
    }

    function getMainSlider() {
      return $('#product .product__slider .slider__slides');
    }

    function goToVariantImage(variantId, $option, attempt) {
      attempt = attempt || 0;
      var $slider = getMainSlider();

      if (!$slider.length) return;

      if (!$slider.hasClass('slick-initialized')) {
        if (attempt < 20) {
          setTimeout(function () {
            goToVariantImage(variantId, $option, attempt + 1);
          }, 100);
        }
        return;
      }

      var featuredMediaId = $option && $option.attr('data-featured-media-id');
      var featuredImageId = $option && $option.attr('data-featured-image-id');
      var variant = findProductVariant(variantId);
      var featuredSrc =
        variant && variant.featured_image ? variant.featured_image.src : '';
      var featuredBase = normalizeImageFilename(featuredSrc);

      if (
        variant &&
        variant.featured_image &&
        variant.featured_image.id &&
        !featuredImageId
      ) {
        featuredImageId = String(variant.featured_image.id);
      }

      if (
        variant &&
        variant.featured_media &&
        variant.featured_media.id &&
        !featuredMediaId
      ) {
        featuredMediaId = String(variant.featured_media.id);
      }

      var targetIndex = -1;

      $slider.find('.slick-slide:not(.slick-cloned)').each(function () {
        var $slide = $(this);
        var mediaId =
          $slide.attr('data-media-id') ||
          $slide.find('[data-media-id]').first().attr('data-media-id');
        var slickIndex = parseInt($slide.attr('data-slick-index'), 10);

        if (
          mediaId &&
          ((featuredMediaId && String(mediaId) === String(featuredMediaId)) ||
            (featuredImageId && String(mediaId) === String(featuredImageId)))
        ) {
          targetIndex = slickIndex;
          return false;
        }

        var variantsAttr = '';
        $slide.find('[data-variants]').each(function () {
          var value = $(this).attr('data-variants');
          if (value) {
            variantsAttr = variantsAttr ? variantsAttr + ',' + value : value;
          }
        });

        if (variantsAttr) {
          var ids = variantsAttr.split(',');
          for (var i = 0; i < ids.length; i++) {
            if (ids[i] && String(ids[i].trim()) === String(variantId)) {
              targetIndex = slickIndex;
              return false;
            }
          }
        }

        if (featuredBase) {
          var $img = $slide.find('img').first();
          if ($img.length) {
            var srcBase = normalizeImageFilename($img.attr('src'));
            if (srcBase && srcBase === featuredBase) {
              targetIndex = slickIndex;
              return false;
            }
          }
        }
      });

      if (targetIndex < 0) return;

      $slider.slick('slickGoTo', targetIndex);

      $slider.find('[data-variants]').removeClass('current');
      $slider
        .find('.slick-slide:not(.slick-cloned)[data-slick-index="' + targetIndex + '"]')
        .find('[data-variants]')
        .addClass('current');
    }

    $(document).on('change', '.product-single__variants', function () {
      var $select = $(this);
      var $option = $select.find('option:selected');
      goToVariantImage($select.val(), $option);
    });
  }
});
